/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, computed, toJS, flow } from 'mobx';
import errorsStore from './errorsStore';
import find from 'lodash/find';
import filter from 'lodash/filter';
import get from 'lodash/get';
import set from 'lodash/set';
import _ from '../translations';
import appStore from './appStore';

const defaultTasks = [
    {
        _id: 1,
        description: 'Create admin accounts for team collaboration',
        linkTo: '/administration/users/list',
    },
    {
        _id: 2,
        description: 'Configure your application’s architecture',
        linkTo: '/app-builder/site-map',
    },
    {
        _id: 3,
        description: 'Choose a template and color palette for your application',
        linkTo: '/app-builder/layout',
    },
    {
        _id: 4,
        description: 'Create some categories to classify your content',
        linkTo: '/contents/categories/detail/',
    },
    {
        _id: 5,
        description: 'Create different types of customized contents',
        linkTo: '/contents/types/detail/',
    },
    {
        _id: 6,
        description: 'Add an image to the image library',
        linkTo: '/contents/media-library/images/detail',
    },
    {
        _id: 7,
        description: 'Upload a video to the video library',
        linkTo: '/contents/media-library/videos/detail',
    },
    {
        _id: 8,
        description: 'Create your first Live or VOD content',
        linkTo: '/contents/content-manager/vod/detail/new/',
    },
    {
        _id: 9,
        description: 'Write your first post',
        linkTo: '/contents/content-manager/news/detail/',
    },
    {
        _id: 10,
        description: 'Add a playlist to your application',
        linkTo: '/playlist-manager/list',
    },
    {
        _id: 11,
        description: 'Publish your application in all platforms',
        linkTo: '/app-builder/store-presence',
    },
    {
        _id: 12,
        description: 'Create your first access group to determine who may access your content',
        linkTo: '/contents/access-groups/detail/',
    },
    /*{
    _id: 13,
    description: 'Create your first advertising campaign',
    linkTo: '/monetization/advertising-campaigns'
  },*/
    {
        _id: 14,
        description: 'Access the tutorial section',
        linkTo: '/help-center/tutorials',
    },
    {
        _id: 15,
        description: 'Create your first product',
        linkTo: '/monetization/products/products/list',
    },
];

class TasksStore {
    @observable tasks = defaultTasks;

    @action
    reset = () => {
        this.tasks = defaultTasks;
    };

    @action.bound
    getTasks = flow(function*() {
        if (!appStore.app || !appStore.app._id) {
            yield appStore.getApp();
        }
        let app = toJS(appStore.app);
        this.tasks = get(app, 'settings.tasks', defaultTasks);
    });

    @action.bound
    markAsDone = flow(function*(_id) {
        if (!appStore.app || !appStore.app._id) {
            yield this.getTasks();
        }

        let tasks = toJS(this.tasks);
        let task = find(tasks, { _id });
        if (task.done === true) return;

        task.done = true;
        this.tasks = tasks;
        errorsStore.addInfo(
            {
                userMessage: task.description,
            },
            _('You have completed a task!\n')
        );

        let app = toJS(appStore.app);
        set(app, 'settings.tasks', toJS(this.tasks));
        yield appStore.replaceApp(app);
    });

    @action.bound
    markAsUndone = flow(function*(_id) {
        if (!appStore.app || !appStore.app._id) {
            yield this.getTasks();
        }
        let tasks = toJS(this.tasks);
        let task = find(tasks, { _id });
        if (task.done === false) return;
        task.done = false;
        this.tasks = tasks;
        let app = toJS(appStore.app);
        set(app, 'settings.tasks', toJS(this.tasks));
        yield appStore.replaceApp(app);
    });

    @computed
    get done() {
        return filter(toJS(this.tasks), task => !!task.done);
    }

    @computed
    get undone() {
        return filter(toJS(this.tasks), task => !task.done);
    }

    @computed
    get percentComplete() {
        return parseInt((toJS(this.done).length / toJS(this.tasks).length) * 100, 10);
    }
}

export default new TasksStore();
